import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Mint from "./components/Mint";

import Home from "./components/Home";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route exact path="/mint" element={<Mint />} />
      </Routes>
    </Router>
  );
}

export default App;
